import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChange } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgForm } from "@angular/forms";
import { Router } from '@angular/router';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { AppConstants, CARGO_STATUS, SCHEDULE, DATEPICKER } from '../app.constants';
import { CarService, Car } from '../member-kanri/car.service';
import { UserService, User } from '../member-kanri/user.service';
import { ScheduleService, Schedule } from './schedule.service';
import { CommonService } from '../app.service';
import { MessageService } from '../common/message.service';
import $ from 'jquery';


@Component({
    selector: 'schedule-main',
    templateUrl: 'schedule-main.component.html',
    providers: [ScheduleService, UserService, CarService]
})
export class ScheduleMainComponent implements OnInit, OnDestroy, OnChanges {

    SCHEDULE: any = SCHEDULE;
    CONST: any = AppConstants;

    @Input()
    page_div: string = "main";

    @Input()
    startDate: Date;

    @Input()
    selCar: Car;

    @Input()
    cargoStatus: string;

    @Output()
    selectCar = new EventEmitter<number>();

    @ViewChild(NgForm) f: NgForm;

    scheduleDatePickerOptions: INgxMyDpOptions = DATEPICKER.myDatePickerOptions_noDisableUntil;

    div_width: number = SCHEDULE.CELL_WIDTH;
    div_height: number = SCHEDULE.CELL_HEIGHT;

    weekdays: WeekDays[];
    weekdaySize: number = SCHEDULE.WEEKDAY_SIZE;
    weekdayIndex: number = 0;
    todayYMD: string;
    startYMD: string;
    
    carList: Car[];
    driverList: User[];

    currentSchedule: Schedule;
    scheduleList: Schedule[];

    scheduleButtonList: ScheduleButton[] = [];

    transCarId: number;

    modalErrorMsg: string = "";
    

    constructor(
        private router: Router,
        private carService: CarService,
        private userService: UserService,
        private scheduleService: ScheduleService,
        private commonService: CommonService,
        private datePipe: DatePipe,
        private msgService: MessageService
    ) {  }
 

    ngOnInit() {
        this.todayYMD = this.datePipe.transform(new Date(), 'yyyyMMdd');

        if (this.page_div == 'main') {
            this.startDate = new Date();
            this.startDate.setDate(this.startDate.getDate() - 4);
        } else {
            this.weekdaySize = SCHEDULE.WEEKDAY_SIZE_SM;
            this.div_width = SCHEDULE.CELL_WIDTH_SM;
            this.div_height = SCHEDULE.CELL_HEIGHT_SM;
        }

        this.refreshPage();

        $(window).resize(function() {
            if ($(window).width() < 1180) {
                //
            }
        });
    }


    refreshPage() {
        $('#scheduleModal').modal('hide');
        this.scheduleButtonList = [];
        this.clearCurrentSchedule();
        this.getWeekdays();
        this.getDriverList();
        this.getCarList();
        this.msgService.clearError();
    }


    clearCurrentSchedule() {
        let now = new Date();
        this.currentSchedule = new Schedule();
        this.currentSchedule.div = this.SCHEDULE.CAR_SCHEDULE;
        this.currentSchedule.allday_flag = true;
        this.currentSchedule.start_date = { jsdate: now, formatted: now.toLocaleDateString() };
        this.currentSchedule.end_date = { jsdate: now, formatted: now.toLocaleDateString() };
        this.currentSchedule.start_time = "09";
        this.currentSchedule.end_time = "18";
    }


    getWeekdays() {
        this.weekdays = []
        let d = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate(), 0, 0, 0);
        d.setDate(d.getDate() + (this.weekdaySize * this.weekdayIndex));
        
        for (let i=1; i<=this.weekdaySize; i++) {
            d.setDate(d.getDate()+1);
            var dayOfWeek = d.getDay();
            var dayOfWeekStr = [ "日", "月", "火", "水", "木", "金", "土" ][dayOfWeek];
            this.weekdays.push(new WeekDays(this.datePipe.transform(d,'yyyyMMdd'), d.toLocaleDateString(), ((d.getMonth()+1) + "/" + d.getDate() + "(" + dayOfWeekStr + ")"), dayOfWeekStr));
        }
    }


    getDriverList() {
        this.userService.getDriverList(1, false, true)
            .subscribe(
                data => {
                    this.driverList = data['results'];
                }
            );
    }
    

    getCarList() {
        this.carList = this.carService.getDispatchTargetCarList();
        this.getScheduleList();
        this.getTransScheduleList();
    }
    

    getScheduleList() {
        this.scheduleService.getScheduleList(this.weekdays[0].ymd, this.weekdays[this.weekdays.length-1].ymd)
        .subscribe(
            data => {
                this.scheduleList = data['results'];
                this.makeScheduleButton(data['results']);
            }
        );
    }


    getTransScheduleList() {
        this.scheduleService.getCarTransScheduleList(this.weekdays[0].ymd, this.weekdays[this.weekdays.length-1].ymd)
        .subscribe(
            data => {
                this.makeScheduleButton(data['results']);
                this.changeSelectCar();
            }
        );
    }



    makeScheduleButton(scheduleList: Schedule[]) {
        let car_index = -1;
        let start_time = 0;
        let top = 0;
        let left = 0;
        let width = 0;
        for (var i=0; i<scheduleList.length; i++) {
            if (scheduleList[i].div == this.SCHEDULE.DRIVER_SCHEDULE) {
                car_index = this.carList.findIndex(({driver_id}) => driver_id === scheduleList[i].div_id);
                top = (car_index * this.div_height) + (this.page_div=='main'?3.6:2.6);
            } else {
                car_index = this.carList.findIndex(({id}) => id === scheduleList[i].div_id);
                top = (car_index * this.div_height) + (scheduleList[i].div==this.SCHEDULE.CAR_SCHEDULE?(this.page_div=='main'?1.8:1.3):0.1);
            }
            
            if (car_index != -1) {
                start_time = (new Date(scheduleList[i].button_start_date)).getHours();
                left = (this.page_div=='main'?3.5:0) + ((scheduleList[i].dayindex+1)*this.div_width) + (scheduleList[i].allday_flag?0:(Math.round(this.div_width*start_time/24*10)/10));
                width = Math.round(this.div_width * scheduleList[i].hourdiff / 24 * 10) / 10;
                this.scheduleButtonList.push(new ScheduleButton(scheduleList[i].div, scheduleList[i].id, scheduleList[i].title, top+"rem", left+"rem", width+"rem", scheduleList[i].tooltip));
            }
        }
    }


    scheduleClick(div: string, click_id: number) {
        if (div != SCHEDULE.TRANS_SCHEDULE) {
            this.currentSchedule = Object.assign({}, this.scheduleList.find(({id})=>id===click_id));
            this.convertDateForDatepicker();
            if (this.currentSchedule.div == this.SCHEDULE.CAR_SCHEDULE) {
                this.currentSchedule.car_id = this.currentSchedule.div_id;
            } else {
                this.currentSchedule.driver_id = this.currentSchedule.div_id;
            }
            this.scheduleModalShow(this.SCHEDULE.UPDATE, null, undefined, null);
        }
    }


    convertDateForDatepicker() {
        let sd = new Date(this.currentSchedule.start_date);
        let ed = new Date(this.currentSchedule.end_date);
        this.currentSchedule.start_date = { jsdate: sd, formatted: sd.toLocaleDateString() };
        this.currentSchedule.end_date = { jsdate: ed, formatted: ed.toLocaleDateString() };
    }


    scheduleModalShow(execDiv: string, localeYmd: string, car_id: number, driver_id: number) {
        if (execDiv == this.CONST.REGIST) {
            this.clearCurrentSchedule();
            $('#scheduleModal .modal-title').text('スケジュール登録');

            if (localeYmd) {
                this.currentSchedule.car_id = car_id;
                this.currentSchedule.driver_id = driver_id;
                this.currentSchedule.start_date = { jsdate: new Date(localeYmd), formatted: localeYmd };
                this.currentSchedule.end_date = { jsdate: new Date(localeYmd), formatted: localeYmd };
            }
        } else {
            $('#scheduleModal .modal-title').text('スケジュール修正／削除');
        }

        this.modalErrorMsg = "";
        $('#scheduleModal').modal('show');
    }


    prevWeekdays() {
        this.weekdayIndex -= 1;
        this.refreshPage();
    }

    nextWeekdays() {
        this.weekdayIndex += 1;
        this.refreshPage();
    }

    moveToday() {
        if (this.weekdayIndex != 0) {
            this.weekdayIndex = 0;
            this.refreshPage();
        }
    }


    scheduleRegist() {
        if(this.commonService.checkStartEndDate(this.currentSchedule.start_date, this.currentSchedule.start_time, this.currentSchedule.end_date, this.currentSchedule.end_time, this.currentSchedule.allday_flag, false, false)) {
            this.scheduleService.registSchedule(this.currentSchedule)
                .subscribe(
                    data => {
                        this.refreshPage();
                    },
                    error => {
                        this.convertDateForDatepicker();
                        this.modalErrorMsg = error.error.detail;
                        this.msgService.clearError();
                    }
                );
        }
    }


    scheduleUpdate() {
        if(this.commonService.checkStartEndDate(this.currentSchedule.start_date, this.currentSchedule.start_time, this.currentSchedule.end_date, this.currentSchedule.end_time, this.currentSchedule.allday_flag, false, false)) {
            this.scheduleService.updateSchedule(this.currentSchedule)
                .subscribe(
                    data => {
                        this.refreshPage();
                    },
                    error => {
                        this.convertDateForDatepicker();
                        this.modalErrorMsg = error.error.detail;
                        this.msgService.clearError();
                    }
                );
        }
    }


    scheduleDelete() {
        $('#confirmModal').modal('hide');
        $('#scheduleModal').modal('hide');
        this.scheduleService.deleteSchedule(this.currentSchedule)
            .subscribe(
                data => {
                    this.scheduleButtonList.splice(this.scheduleButtonList.findIndex(({div,id}) => div===this.currentSchedule.div && id === this.currentSchedule.id), 1);
                }
            );
    }




    /////// 配車管理画面用 ///////////////////////
    ngOnChanges(changes: {[key: string]: SimpleChange}): void {
        if (changes['startDate']) {
            this.startYMD = this.datePipe.transform(this.startDate, 'yyyyMMdd');
            this.startDate.setDate(this.startDate.getDate() - 3);
            this.refreshPage();
        }
        else if (changes['selCar'] && !changes['selCar'].firstChange) {
            this.changeSelectCar();
        }
    }

    changeSelectCar() {
        //現在選択中のボタンを解除する
        $('input[name=trans_car]').parent('.btn').removeClass('disabled');
        $('input[name=trans_car]:checked').parent('.btn').removeClass('active');
        $('input[name=trans_car]:checked').parent('.btn').removeClass('btn-primary');
        $('input[name=trans_car]:checked').parent('.btn').addClass('btn-outline-primary');
        $('input[name=trans_car]:checked').prop('checked',false);
        
        if (this.selCar && this.selCar.id) {
            $('#trans_car_'+this.selCar.id).prop('checked',true);
            $('input[name=trans_car]:checked').parent('.btn').addClass('active');

            if (this.cargoStatus == CARGO_STATUS.MATCH_CAR) {
                $('input[name=trans_car]').parent('.btn').addClass('disabled');
                $('input[name=trans_car]:checked').parent('.btn').removeClass('disabled');
                $('input[name=trans_car]:checked').parent('.btn').removeClass('btn-outline-primary');
                $('input[name=trans_car]:checked').parent('.btn').addClass('btn-primary');
            }
        }
    }

    checkCar(car_id: number): void {
        if (this.cargoStatus != CARGO_STATUS.MATCH_CAR) {
            this.selectCar.emit(car_id);
        }
    }
    ////////////////////////////////////////////


    ngOnDestroy() {
        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }

}



export class WeekDays {
    ymd: string;        //yyyyMMdd
    localeYmd: string;  //yyyy/MM/dd
    weekday: string;
    dayOfWeekStr: string;

    constructor(ymd, localeYmd, weekday, dayOfWeekStr) {
        this.ymd = ymd;
        this.localeYmd = localeYmd;
        this.weekday = weekday;
        this.dayOfWeekStr = dayOfWeekStr;
    }
}



export class ScheduleButton {
    div: string;
    id: number;
    title: string;
    top: string;
    left: string;
    width: string;
    tooltip: string;

    constructor(div, id, title, top, left, width, tooltip) {
        this.div = div;
        this.id = id;
        this.title = title;
        this.top = top;
        this.left = left;
        this.width = width;
        this.tooltip = tooltip;
    }
}



// WEBPACK FOOTER //
// ./src/app/schedule/schedule-main.component.ts